module.exports = __webpack_public_path__ + "static/media/img5.34685646.jpg";